import React, { Fragment } from 'react';
import { SchoolListing } from '../types/api';
import { SchoolCard } from './SchoolCard';
import { Sidebar } from './Sidebar';
interface SchoolListingsProps {
  schools: SchoolListing[];
  loading: boolean;
  error: string | null;
  selectedAreaId: number;
  selectedProgram: number;
  onProgramChange: (programId: number) => void;
  hideSidebar?: boolean;
}
export function SchoolListings({
  schools,
  loading,
  error,
  selectedAreaId,
  selectedProgram,
  onProgramChange,
  hideSidebar = false
}: SchoolListingsProps) {
  return <div className="w-full max-w-7xl mx-auto px-4 py-6 md:py-8" data-id="element-285" data-mp="2gb8itchwotry">
      <div className={`flex flex-col ${hideSidebar ? '' : 'lg:flex-row'} gap-6`} data-id="element-286" data-mp="2l91nu27h3hqn">
        {/* Main Content Area */}
        <div className={`w-full ${hideSidebar ? '' : 'lg:flex-1'} min-w-0`} data-id="element-287" data-mp="2qar17oi647hw">
          {error && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6" data-id="element-288" data-mp="j2j01lq5os9">
              <p className="font-medium" data-id="element-289" data-mp="5hm645c216m7">Error loading schools</p>
              <p className="text-sm" data-id="element-290" data-mp="2gchjgqpjddl3">{error}</p>
            </div>}

          {loading ?
        // Skeleton Loading State
        <div className="space-y-6" data-id="element-291" data-mp="2bcmp2d6jy5va">
              {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8 flex flex-col md:flex-row gap-6 animate-pulse" data-id="element-292" data-mp="27b9k05baa6pf">
                  <div className="w-16 h-16 bg-gray-200 rounded-full flex-shrink-0" data-id="element-293" data-mp="22bexsf2ge5ap"></div>
                  <div className="flex-grow space-y-4" data-id="element-294" data-mp="1xe55mrnojfj6">
                    <div className="h-6 bg-gray-200 rounded w-3/4" data-id="element-295" data-mp="1smdhenrzxlw7"></div>
                    <div className="space-y-2" data-id="element-296" data-mp="1skagh8pb28cp">
                      <div className="h-4 bg-gray-200 rounded w-full" data-id="element-297" data-mp="1nmipqi0ecsa3"></div>
                      <div className="h-4 bg-gray-200 rounded w-5/6" data-id="element-298" data-mp="1jloybenqwvcg"></div>
                      <div className="h-4 bg-gray-200 rounded w-4/6" data-id="element-299" data-mp="1jjm2uf3tqa0c"></div>
                    </div>
                  </div>
                  <div className="w-full md:w-48 h-12 bg-gray-200 rounded-lg flex-shrink-0 mt-4 md:mt-0" data-id="element-300" data-mp="19nj3ti49qrhm"></div>
                </div>)}
            </div> : schools.length === 0 && !error ? <div className="bg-gray-50 border border-gray-200 text-gray-600 px-6 py-12 rounded-xl text-center" data-id="element-301" data-mp="101zxtgbi45lt">
              <p className="text-lg font-medium mb-2" data-id="element-302" data-mp="14wne4rwcptpb">
                No schools found for this area of study.
              </p>
              <p data-id="element-303" data-mp="v0aktv4pxhv3">Please try selecting a different category.</p>
            </div> : <div className="space-y-5" data-id="element-304" data-mp="v2n9ss8w8shn">
              {schools.map((school, index) => <Fragment key={`${school.mBrandID}-${index}`} data-id="element-305" data-mp="1ir6jnc7lddbu" data-mpi={index}>
                  <SchoolCard school={school} rank={index + 1} isRecommended={index === 0} data-id="element-306" data-mp="1npr9qit4qgmk" />
                  {index === 0 && schools.length > 1 && <div className="flex items-center justify-center gap-4 bg-gray-50 border border-gray-200 rounded-lg px-5 py-3" data-id="element-307" data-mp="19022c5ug1gdu">
                      <div className="flex items-center gap-2 flex-shrink-0" data-id="element-308" data-mp="21p92185mwc0o">
                        <span className="bg-yellow-400 rounded-full w-8 h-8 flex items-center justify-center text-lg" data-id="element-309" data-mp="21n61vvarp2i8">
                          💡
                        </span>
                        <span className="text-xs font-bold text-gray-900 uppercase tracking-wider" data-id="element-310" data-mp="3r4tif2krfi0r">
                          Did You Know?
                        </span>
                      </div>
                      <span className="text-sm text-gray-700" data-id="element-311" data-mp="4qa4t83m06vc">
                        Enrollments increased by 40% this year
                      </span>
                    </div>}
                </Fragment>)}
            </div>}
        </div>

        {/* Sidebar Area - only show if hideSidebar is false */}
        {!hideSidebar && <div className="w-full lg:w-56 xl:w-64 flex-shrink-0" data-id="element-312" data-mp="33aa3bo1gcwn8">
            <Sidebar selectedAreaId={selectedAreaId} selectedProgram={selectedProgram} onProgramChange={onProgramChange} data-id="element-313" data-mp="3h99mwha3ylcj" />
          </div>}
      </div>
    </div>;
}